import { useCallback } from "react";

import type { SubOptionItemInput } from "@/lib/gql/__generated__/graphql";

import type { ForAutoGenerator } from "@/components/features/_model/types/auto-generator-for-view-model";
import { QuestionCardItem } from "@/components/features/items/edit/_shared/ui/components/system/question/card/card-item";

import { SubOptionItem } from "./sub-option-item";

export type SubOptionRowProps = {
	subOption: ForAutoGenerator<SubOptionItemInput, "">;
	index: number;

	removeSubOption: (index: number) => void;

	onSetSubOptionName: (name: string, index: number) => void;
	onSetIsShowTimeSchedule: (props: {
		isShowTimeSchedule: boolean;
		index: number;
		startAt: string;
		endAt: string;
	}) => void;
	onSetStartAt: (startAt: string, index: number) => void;
	onSetEndAt: (endAt: string, index: number) => void;
	onSetIsNextMorning: (isNextMorning: boolean, index: number) => void;
	onSetMaxDailyStockNum: (maxDailyStockNum: number | undefined, index: number) => void;
	onSetPriceAmount: (priceAmount: number | undefined, index: number) => void;
};

/** 並べ替えなしの1行。複数件でDnDする場合は `SortableSubOptionRow` を使う。 */
export const SubOptionRow = ({
	subOption,
	index,
	removeSubOption,
	onSetSubOptionName,
	onSetIsShowTimeSchedule,
	onSetStartAt,
	onSetEndAt,
	onSetIsNextMorning,
	onSetMaxDailyStockNum,
	onSetPriceAmount,
}: SubOptionRowProps) => {
	const handleRemoveItem = useCallback(() => {
		removeSubOption(index);
	}, [removeSubOption, index]);

	return (
		<QuestionCardItem removeItem={handleRemoveItem}>
			<SubOptionItem
				subOption={subOption}
				index={index}
				onSetSubOptionName={onSetSubOptionName}
				onSetIsShowTimeSchedule={onSetIsShowTimeSchedule}
				onSetStartAt={onSetStartAt}
				onSetEndAt={onSetEndAt}
				onSetIsNextMorning={onSetIsNextMorning}
				onSetMaxDailyStockNum={onSetMaxDailyStockNum}
				onSetPriceAmount={onSetPriceAmount}
			/>
		</QuestionCardItem>
	);
};

SubOptionRow.displayName = "SubOptionRow";
